import axios, { AxiosPromise } from 'axios';

import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';

export interface IEmiseKorpAkce {
    sezemise: ISezemiseKorpAkce[];
}
export interface ISezemiseKorpAkce {
    isin: string;
    nazevemise: string;
    lei: string;
}
const kontrolaXMLucastnik = (
    tempnazev: string,
    fileName: string,
    typudalosti?: ETypUdalosti | null,
    idSRD?: number | string
): AxiosPromise<IEmiseKorpAkce> | null => {
    if (!fileName || !typudalosti) return null;
    return axios({
        method: 'POST',
        url: `Ucastnik/${idSRD}/KontrolaXML`,
        data: {
            tmp: tempnazev,
            nazevsouboru: fileName,
            id: idSRD,
            typudalosti
        }
    });
};
export default kontrolaXMLucastnik;
